import { Sparkles, Construction } from 'lucide-react';
import { Card, CardHeader } from '../_primitives';

export interface SocialPlatform {
  id: string;
  label: string;
  /** Brand color used for the dot marker. */
  color: string;
}

export interface SocialRepurposeCardProps {
  platforms?: SocialPlatform[];
  initialSelected?: string[];
  onGenerate?: (selectedIds: string[]) => void;
  generating?: boolean;
}

/**
 * Social repurpose card — currently under construction. The interactive
 * platform-selection + generate UI is parked behind a "Coming soon"
 * placeholder. Props signature is kept intact so callers don't break; the
 * props are intentionally unused while the feature is disabled.
 */
export function SocialRepurposeCard(_props: SocialRepurposeCardProps) {
  return (
    <Card railSection="social">
      <CardHeader
        icon={<Sparkles className="size-3.5" />}
        title="Repurpose for social"
        trailing={
          <span className="inline-flex items-center gap-1 rounded-full border border-coral/30 bg-coral-light px-2 py-0.5 text-[10px] font-semibold text-coral-dark">
            <Construction className="size-3" />
            Coming soon
          </span>
        }
      />
      <div className="px-3 pb-4 pt-1">
        {/* Actions intentionally disabled (not hidden) while under construction. */}
        <div className="flex flex-col items-center text-center gap-2 py-3 opacity-70">
          <Construction className="size-6 text-muted-foreground" />
          <div className="text-[12px] font-semibold text-foreground">Coming soon</div>
          <div className="text-[11px] text-muted-foreground leading-snug max-w-[200px]">
            Social repurposing is under construction.
          </div>
          <button
            type="button"
            disabled
            aria-disabled="true"
            className="mt-1 cursor-not-allowed rounded-md border border-border bg-warm-bg px-3 py-1 text-[11.5px] font-semibold text-muted-foreground"
          >
            Generate posts
          </button>
        </div>
      </div>
    </Card>
  );
}
